import React, { useEffect, useRef, useContext, createContext } from 'react'
import NoAttachments from '../WebcastAttachments/NoAttachments'
import AttachmentsLists from '../WebcastAttachments/AttachmentsLists'
import AttachmentsForm from '../WebcastAttachments/AttachmentsForm'
import DeleteAttachmentAlert from '../WebcastAttachments/DeleteAttachmentAlert'
import PropTypes from './types'
import componentStyles from './Attachments.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import classNames from 'classnames'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import useInterval from '@bt-react/libs/useInterval'
import { useState } from 'react'
import { MutableRefObject } from 'react-dom/node_modules/@types/react'


const IsNarrowViewContext = createContext(false)

export const useIsNarrowView = () => {
    return useContext(IsNarrowViewContext)
}

const Attachments: React.FC<PropTypes> = (props) => {

    const { fetchResourceData, channelId, webcastId, view, resourceData, isOpen, status, userTimezone, webcastData, isCentral } = props

    const [isPolling, setIsPolling] = useState(false)
    const containerRef = useRef() as MutableRefObject<HTMLDivElement>
    const [isNarrowView, setIsNarrowView] = useState(false)

    useEffect(() => {
        if (isOpen) fetchResourceData(channelId, webcastId)        
    }, [isOpen])

    useInterval(async () => {
        if (isOpen && view === 'lists' && webcastData.status === 'upcoming' && !status.isProcessing) {
            setIsPolling(true)
            await fetchResourceData(channelId, webcastId)
            setIsPolling(false)
        }
    }, 10000)

    useEffect(() => {

        if (containerRef && containerRef?.current && containerRef?.current.offsetWidth <= 530) {
            setIsNarrowView(true)
        }
    }, [])

    const getContent = () => {
        if (status && status.isLoading && !isPolling) {
            return (
                <div data-bdd='syndication-spinner' className= {componentStyles['spinner']}>
                    <FontAwesomeIcon icon={faSpinner} spin className={classNames(componentStyles['fa-spinner'])} />
                </div>
            )
        } 
        if (view === 'lists' || status && status.isUploading) {
            if (resourceData.length || status.isUploading || status.isProcessing || (resourceData.length && isPolling)) {
                return (
                    // @ts-ignore
                    <DndProvider backend={HTML5Backend}>
                        <AttachmentsLists channelId={channelId} webcastId={webcastId} resourceData={resourceData} isCentral={isCentral} />
                    </DndProvider>
                )
            } else {
                return (
                    <NoAttachments channelId={channelId} webcastId={webcastId} isCentral={isCentral}/>
                ) 
            }
        } else if (view === 'add') {
            return (
                <AttachmentsForm channelId={channelId} webcastId={webcastId} userTimezone={userTimezone} isCentral={isCentral}/>
            )
        } else if (view === 'delete') {
            return (
                <DeleteAttachmentAlert channelId={channelId} webcastId={webcastId} isCentral={isCentral} attachments={true} />
            )
        }else {
            return (
                <div data-bdd='syndication-spinner' className= {componentStyles['spinner']}>
                <FontAwesomeIcon icon={faSpinner} spin className={classNames(componentStyles['fa-spinner'])} />
            </div>
            ) 
        }
    }

    return <div ref={containerRef}>
        <IsNarrowViewContext.Provider value={isNarrowView}>
            {getContent()}
        </IsNarrowViewContext.Provider>
        </div>
}

export default Attachments
